import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@iconify/react';
import mdClose from '@iconify/icons-ion/md-close';
import styles from '../../badging.module.scss';
import attachmentStyles from '../../Detail/detail.module.scss';
import { acceptFilesList } from '../../../../utils/helpers';
import PulpoField from '../../../../pulpo_visualizer/fields';
import Clickable from '../../../../components/clickable/Clickable';
import Modal from '../../../../components/modal';
import FileSlider from '../../../../components/photoCarousel/FileSlider';


const AttachmentsList = ({
  requiredAttachments,
  handleAnswerChanged,
  handleRemoveImage,
  handleDropList,
  handleAddmore,
  handleRemoveRow,
  field,
  requiredAttachmentsErrors,
  showFormErrors,
  dropDownValues = [],
  list
}) => {
  const [isModalOpen, setModal] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const getValues = (rowToExclude) => {
    const values = [];
    Object.keys(requiredAttachments[list]).forEach((rowKey) => {
      if (rowKey !== rowToExclude) {
          if (requiredAttachments[list][rowKey].file_name!=='') {
            values.push(requiredAttachments[list][rowKey].file_name);
          }
      }
    });
    return dropDownValues.filter(item => !values.includes(item.key));
  };

  const handleAttachmentModal = (e) => {
    setAttachment(e);
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
  };
  const titles = {
    attachments_lista: 'List A Documents',
    attachments_listb: 'List B Documents',
    attachments_listc: 'List C Documents'
  };

  const title = titles[list?.toLowerCase()] || 'Unknown Documents';

  const getSettingsIfTitleMatches = () => {
    const fieldId = field.id.replace(/_/g, '').toLowerCase();
    const matchedKey = Object.keys(titles).find(key => key.replace(/_/g, '').toLowerCase() === fieldId);
    return matchedKey
      ? { settings: field.settings, title: titles[matchedKey] }
      : null;
  };

  const attachmentSettings = getSettingsIfTitleMatches();
  const validationKeys = attachmentSettings?.settings?.req_docs_for_validation || [];
  return (
    <div className={styles.attachmentsListContainer}>
      {Object.keys(requiredAttachments || {}).length > 0 && (
        <>
            {Object.keys(requiredAttachments?.[list] || {}).map((eachRow, index) => (
              <div className={styles.container} key={eachRow}>
                {
                  Object.keys(requiredAttachments?.[list]?.[eachRow] || {}).map(eachField => (
                    <div className={styles.eachRow} key={`${eachRow}`}>
                        {eachField === 'file_name' && (
                          <div className={styles.eachField} key={`${eachField}`}>
                            <PulpoField
                              key={`${eachRow}_${eachField}`}
                              id={`${eachRow}_${eachField}`}
                              type="select"
                              isRequired={field.required}
                              title={eachRow === 'row_0'? title :' '}
                              handleValueChange={a => handleAnswerChanged('requiredAttachments', a, eachField, list, eachRow)}
                              answer={requiredAttachments?.[list]?.[eachRow]?.[eachField]}
                              handleFieldErrorChanged={() => {}}
                              showFieldErrors={showFormErrors}
                              values={getValues(eachRow)}
                            />
                          </div>
                        )}

                      {eachField === 'expiry_date'
                        && !validationKeys.includes(
                          String(requiredAttachments?.[list]?.[eachRow]?.file_name)
                        ) && (
                          <div className={styles.eachField} key={`${eachField}`}>
                            <PulpoField
                              key={`${eachRow}_${eachField}`}
                              id={`${eachRow}_${eachField}`}
                              type="date"
                              title={eachRow === 'row_0' ? 'Expiration' : ' '}
                              handleValueChange={a => handleAnswerChanged('requiredAttachments', a, eachField, list, eachRow)}
                              answer={requiredAttachments?.[list]?.[eachRow]?.[eachField]}
                              handleFieldErrorChanged={() => { }}
                              showFieldErrors={showFormErrors}
                              isRequired={field.required}
                              settings={{
                                validations: {
                                  condition: {
                                    key: 'greater_than',
                                    name: 'Allow greater than or equal to current date'
                                  },
                                  conditional_days: '0',
                                  between_condition: {
                                    key: 'none',
                                    name: 'None'
                                  }
                                }
                              }}
                            />
                          </div>
                        )}

                        {eachField === 'attachment'
                          && (requiredAttachments?.[list]?.[eachRow]?.[eachField]?.length > 0 ? (
                            <div className={`${styles.linksConatiner} ${field.required
                                && styles.docLink} ${!field?.required && eachRow === 'row_0' && styles.docLink0}`}>
                              {requiredAttachments?.[list]?.[eachRow]?.[eachField].map(e => (
                                <div className={`${styles.badgeImgCard}`}>
                                  <Clickable
                                    key={e.id}
                                    onClick={() => handleAttachmentModal(e)}
                                    className={`${attachmentStyles.pdflink} ${styles.addLink} mt-1`}
                                  >
                                    {e?.file_name ?? e.name}
                                  </Clickable>
                                  <Clickable className={styles.closeIcon}
                                    onClick={() => handleRemoveImage(e, list, eachRow, eachField)}>&times;
                                  </Clickable>
                                </div>
                              ))}
                            </div>
                          )
                            : (
                              <div className={`${styles.attachment} ${field?.required && styles.reqAttachment} 
                                ${!field?.required && eachRow === 'row_0' && styles.attchment0}`}>
                                <Dropzone
                                  onDrop={dropped => handleDropList(dropped, list, eachRow)}
                                  disableClick
                                  className={styles.uploadBtn}
                                  accept={acceptFilesList}
                                >
                                  {({ open }) => (
                                    <>
                                      <button
                                        className={styles.uploadFile}
                                        type="button"
                                        onClick={() => open()}
                                      >
                                        <FormattedMessage id="airport.logo.butto" defaultMessage="upload" />
                                      </button>
                                    </>
                                  )}
                                </Dropzone>
                                {field.required && showFormErrors && requiredAttachmentsErrors[list][eachRow][eachField]
                                && <small style={{ color: 'red' }}>
                                      <FormattedMessage id="pulpoforms.errors.not_blank"
                                        defaultMessage="This field cannot be empty"
                                      />
                                   </small>}
                              </div>
                            )
                          )}

                        {eachField === 'attachment'&& index > +field?.settings?.min_no_of_reqDocs-1 &&(
                        <Icon
                          icon={mdClose}
                          onClick={() => handleRemoveRow(list, eachRow)}
                          height="20"
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                    </div>
                    ))
                }
              </div>
            ))}
            {false && Object.keys(field?.settings?.req_docs || {}).length !== Object.keys(requiredAttachments?.[list]).length
              && (
                <Clickable onClick={() => handleAddmore(list, Object.keys(requiredAttachments?.[list] || {})?.length)} className={styles.addLink}>
                  <FormattedMessage
                    id="pulpofield.string.add_more"
                    defaultMessage="+ Add more"
                  />
                </Clickable>
              )}
            <Modal
              showIn={isModalOpen}
              onClose={() => handleClose()}
              contentStyles={{
                overflow: 'visible',
                background: '#E6EAEE',
                padding: '20px 40px'
              }}
              width="554px"
              minHeight="100px"
            >
              <FileSlider photos={[attachment]} />
            </Modal>
        </>
      )}
    </div>
  );
};

export default AttachmentsList;
